<template>
    <div class="layout-record-top-bar dsp-flex">
        <div class="layout-rtb-side" @click.passive="clickGroup">分组<br>管理</div>
        <div class="layout-rtb-mid">
            <div class="com-search-input">
                <i class="iconfont icon-search com-i-s"></i>
                <input class="com-si-input" type="text" placeholder="搜索" :disabled='true' >
            </div>
            <div class="search-fake-div" @click.passive="clickSearch"></div>
        </div>
        <div class="layout-rtb-side" @click.passive="clickCollate">八字<br>起盘</div>
    </div>
</template>

<script>
import { MIX } from '../../modules/utils';

export default {
    name: 'RecordTopBar',
    computed: {
    },
    methods:{
        clickSearch() {
            this.$store.dispatch('search/resetData');
            this.$store.state.search.searchFromPage = 'record';
            this.$router.replace('/search/record');
            MIX.trackButtonClicked('my_bz_search');
        },
        clickGroup() {
            this.$router.replace('/record/groupmanage');
            MIX.trackButtonClicked('my_bz_group');
        },
        clickCollate() {
            this.$router.replace('/collate')
            MIX.trackButtonClicked('my_bz_qipan');
        }
    }
}
</script>